<template>
  <div />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('auth', [
      'isAuthorized'
    ]),
  },

  created () {
    // redirect
    this.$router.push({ path: (this.isAuthorized ? '/orders' : '/login') })
  }
}
</script>
